import React from 'react';
import Select, { components } from 'react-select';
import { SocialAccountData } from '../../types/influencer/influencerTypes';
import dummyProfilePic from '../../assets/images/avatars/user-dummy-img.jpg';
import './IGAccountSelector.scss';

const ChevronDownIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const IGAccountSelector: React.FC<{
    socialAccount: SocialAccountData | null;
    socialAccounts: SocialAccountData[];
    onChange: (account: SocialAccountData | null) => void;
}> = ({ socialAccount, socialAccounts, onChange }) => {
    const changeSelectedSocialAccount = (accountUuid: string) => {
        const selectedAccount = socialAccounts?.find((a) => a.social_account.uuid === accountUuid) || null;
        onChange(selectedAccount);
    };

    const options = (socialAccounts ?? [])
        .map((a) => ({
            label: `@${a.social_account.handle}`,
            value: a.social_account.uuid,
            profile_picture_url: a.social_account.profile_picture_url,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
        .sort((a) => (a.value === socialAccount?.social_account.uuid ? -1 : 1));

    const SingleValue = (props: any) => {
        const src = props.data.profile_picture_url ?? dummyProfilePic;
        return (
            <components.SingleValue {...props}>
                <span className="ig-account-selector__row">
                    <span className="ig-account-selector__avatar">
                        <img src={src} alt="" />
                    </span>
                    <span className="ig-account-selector__label">{props.data.label}</span>
                </span>
            </components.SingleValue>
        );
    };

    const Option = (props: any) => {
        const src = props.data.profile_picture_url ?? dummyProfilePic;
        return (
            <components.Option {...props}>
                <span className="ig-account-selector__avatar">
                    <img src={src} alt="" />
                </span>
                <span className="ig-account-selector__label">{props.data.label}</span>
            </components.Option>
        );
    };

    const DropdownIndicator = (props: any) => (
        <components.DropdownIndicator {...props}>
            <ChevronDownIcon />
        </components.DropdownIndicator>
    );

    return (
        <Select
            className="social-account-select ig-account-selector"
            classNamePrefix="rs"
            options={options}
            isSearchable={!(options.length <= 1)}
            menuIsOpen={options.length <= 1 ? false : undefined}
            onMenuOpen={options.length <= 1 ? () => {} : undefined}
            value={
                socialAccount
                    ? {
                          label: `@${socialAccount.social_account.handle}`,
                          value: socialAccount.social_account.uuid,
                          profile_picture_url: socialAccount.social_account.profile_picture_url,
                      }
                    : null
            }
            onChange={(opt) => opt && changeSelectedSocialAccount(opt.value)}
            components={{
                Option,
                SingleValue,
                DropdownIndicator,
                IndicatorSeparator: () => null,
            }}
        />
    );
};

export default IGAccountSelector;
